import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'
import { SharedUiContactInfoModule } from '../lib/shared-ui-contact-info.module'
import { ContactInfoDocsComponent } from './contact-info-docs/contact-info-docs.component'
import { ContactInfoExampleComponent } from './contact-info-docs/contact-info-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule,
    SharedUiContactInfoModule
  ],
  declarations: [
    ContactInfoDocsComponent,
    ContactInfoExampleComponent
  ],
  exports: [
    ContactInfoDocsComponent
  ],
})
export class SharedUiContactInfoDocsModule {}
